import { render, staticRenderFns } from "./PolizaContable.vue?vue&type=template&id=649cbd67"
import script from "./PolizaContable.vue?vue&type=script&lang=js"
export * from "./PolizaContable.vue?vue&type=script&lang=js"
import style0 from "./PolizaContable.vue?vue&type=style&index=0&id=649cbd67&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports